import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';

import { Link, useLocation, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Radios from '../../component/Radios';
import queryString from 'query-string';
    
import { addHyphenToPhoneNumber, getBase64, patternPwCker, regEmail } from "../../utils/utils";
import * as APIS from "../../utils/service";

export default function Register2({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const query = queryString.parse(location.search);
    console.log(location);

    const selectFile = useRef(null);

    const [submitflag, setsubmitflag] = useState(false);   

    const [email, setemail] = useState('');   
    const [mbpass, setmbpass] = useState('');   
    const [mbpass2, setmbpass2] = useState('');   
    const [level, setlevel] = useState(2);   


    //console.log(location?.state?.okresultData);
    console.log(location?.state)
    const [reqname, setreqname] = useState(location?.state?.reqname);   
    const [reqsex, setreqsex] = useState((location?.state?.reqsex*1 === 1 ? '남' : '여'));   
    const [reqphpone, setreqphpone] = useState(location?.state?.reqphpone);   
    // const [reqname, setreqname] = useState('홍길동');   
    // const [reqsex, setreqsex] = useState('남');   
    // const [reqphpone, setreqphpone] = useState('01012345678');   
    const [agree_marketing, setagree_marketing] = useState(location?.state?.agree6 ? '1' : '0');   
    const [certificate_number, setcertificate_number] = useState('');   
    
    const [errmsg, seterrmsg] = useState(['', '', '', '']);   
    const [files, setfiles] = useState([]);   
    const [passwordfixedCk, setpasswordfixedCk] = useState(false);   
    
    useEffect(() => {
        //seterrmsg(errmsg?.map(( xe, ie ) => ''));
        setsubmitflag(false);
        if(level === 1){
            if(
                email !== '' &&
                mbpass !== '' &&
                mbpass2 !== ''
            ){
                setsubmitflag(true);
            }
        } else {
            if(
                email !== '' &&
                mbpass !== '' &&
                mbpass2 !== '' &&
                certificate_number !== '' &&
                files?.length > 0
            ){
                setsubmitflag(true);
            }
        }

    }, [email, mbpass, mbpass2, level, certificate_number, files]);

    const registerSubmit = () => {

        if(!patternPwCker.test(mbpass)) {
            seterrmsg(errmsg?.map(( xe, ie ) => ie === 1 ? '8자리 이상 영문,숫자,특수문자로 입력하세요.' : xe));
            return;
        }
        if(mbpass !== mbpass2){
            seterrmsg(errmsg?.map(( xe, ie ) => ie === 1 ? '비밀번호가 일치하지 않습니다.' : xe));
            return;
        }

        dispatch(loadingflas({ loading: true }));
        //navigate('/Storeselctor');
        let sender = {
            name: reqname,
            sex: reqsex,
            hp: reqphpone,
            email: email,
            pw: mbpass,
            level: level,
            certificate_number: certificate_number,
            file_path: {
                base: files[0]?.base64,
                ext: files[0]?.ext
            },
            agree_marketing: agree_marketing,
        }


        console.log(sender);
        APIS.postData('/v1/login/join', sender).then(({ data }) => {
            console.log(data);
            if(data){
                localStorage.setItem("token", data);

                dispatch(
                    useropen({
                        userdata: {login: true}
                    })
                );   

                if(level === 1){
                    navigate('/JoinHelp',{state: {registerName: reqname}});
                    // navigate("/Storetype2Write", {state: {registerName: reqname}});
                } else {
                    navigate('/JoinHelp',{state: {registerName: reqname}});
                    // navigate("/Storeselctor", {state: {registerName: reqname}});
                }
            }
        }).catch(({ response }) => {
            const { data } = response;
            if(data?.code === 0){
                seterrmsg(errmsg?.map(( xe, ie ) => ie === 3 ? data?.msg : xe));
            }
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });   
    }
    return(
        <Layout header={false}>
            <div className='normalform'>
                <div className='normalform_title'>회원 정보를 입력해 주세요.</div>
                <div className='normalform_comment2'>{reqname}({reqsex})</div>
                <div className='normalform_comment2'>{addHyphenToPhoneNumber(reqphpone)}</div>
                <div className='normalform_comment' style={{ marginTop: 20 }}>이메일은 비밀번호 찾기 등에 이용되므로</div>
                <div className='normalform_comment'>수신·확인 가능한 <span style={{ fontWeight: 700, textDecoration: 'underline'}}>실제 이용하는 이메일</span>을 작성해주세요.</div>


                <div className='inputArea'>
                    <Input 
                        className={`inputs`}
                        setValue={setemail}
                        value={email}
                        name="searchvar1"
                        label={'이메일(ID)'}
                        labelstyle={2}
                        error={errmsg[0]}
                        clearflag={true}
                        requireds={true}
                        customplaceholder={true}
                        customplaceholdertxt={'이메일'}
                    />                    
                </div>                        
                <div className='inputArea'>
                    <Input 
                        type={'password'}
                        className={`inputs`}
                        setValue={(e) => {
                            setmbpass(e);
                            if(patternPwCker.test(e)) {
                                setpasswordfixedCk(true);
                            } else {
                                setpasswordfixedCk(false);
                            }
                        }}
                        value={mbpass}
                        name="searchvar2"
                        label={'비밀번호'}
                        labelstyle={2}
                        error={''}
                        clearflag={true}
                        requireds={true}
                        fixedCk={passwordfixedCk}
                        customplaceholder={true}
                        customplaceholdertxt={'비밀번호'}
                    />                    
                </div>                        
                <div className='inputArea'>
                    <Input 
                        type={'password'}
                        className={`inputs`}
                        setValue={setmbpass2}
                        value={mbpass2}
                        name="searchvar3"
                        label={'비밀번호 재입력'}
                        labelstyle={2}
                        error={errmsg[1]}
                        clearflag={true}
                        requireds={true}
                        customplaceholder={true}
                        customplaceholdertxt={'비밀번호 재입력'}
                    />                    
                </div>       

                <Radios
                    label={'회원유형을 선택하세요.'}
                    linetype={'two'}
                    values={level}
                    setvalues={setlevel}
                    namevalue={[
                        {names: '공인중개사', values: 2},
                        {names: '중개보조원', values: 1},
                    ]}
                />      
                {level === 2 &&
                <>
                    <div className='inputArea'>
                        <Input 
                            className={`inputs`}
                            setValue={setcertificate_number}
                            value={certificate_number}
                            name="searchvar"
                            label={'자격증 번호'}
                            labelstyle={2}
                            error={errmsg[2]}
                            clearflag={true}
                            requireds={true}
                            customplaceholder={true}
                            customplaceholdertxt={'자격증 번호'}                        
                        />                    
                    </div> 

                    <div className='normalform_comment' style={{ marginTop: 20 }}>공인중개사 자격증<span style={{ color: 'red' }}>*</span></div>

                    <input type='file' ref={selectFile} style={{ display: 'none' }} onChange={(e) => {
                        let file = e.target.files[0];
                        getBase64(file).then(result => {
                            file["base64"] = result;
                            file["ext"] = file.name.split('.')[1];
                            //console.log("File Is", file);
                            //setfiles([...files, file]);
                            let filesdata = [];
                            filesdata.push(file);
                            setfiles(filesdata);
                        })
                        .catch(err => { console.log(err); });
                    }} />

                    <div className="write_image_list">
                        <button 
                            type="button"
                            onClick={() => {
                                selectFile.current.click();
                            }}
                        >
                            <p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M14.1053 13C14.1053 14.1579 13.1579 15.1053 12 15.1053C10.8421 15.1053 9.89474 14.1579 9.89474 13C9.89474 11.8421 10.8421 10.8947 12 10.8947C13.1579 10.8947 14.1053 11.8421 14.1053 13ZM22 10.8947V16.1579C22 18.7632 19.8684 20.8947 17.2632 20.8947H6.73684C4.13158 20.8947 2 18.7632 2 16.1579V10.8947C2 8.36842 3.97368 6.31579 6.44737 6.15789L7.76316 4.15789C8.26316 3.42105 9.07895 3 9.94737 3H14C14.8947 3 15.6842 3.44737 16.1842 4.15789L17.5 6.15789C20.0263 6.31579 22 8.36842 22 10.8947ZM16.2105 13C16.2105 10.6842 14.3158 8.78947 12 8.78947C9.68421 8.78947 7.78947 10.6842 7.78947 13C7.78947 15.3158 9.68421 17.2105 12 17.2105C14.3158 17.2105 16.2105 15.3158 16.2105 13ZM19.3684 9.84211C19.3684 9.26316 18.8947 8.78947 18.3158 8.78947C17.7368 8.78947 17.2632 9.26316 17.2632 9.84211C17.2632 10.4211 17.7368 10.8947 18.3158 10.8947C18.8947 10.8947 19.3684 10.4211 19.3684 9.84211Z" fill="#6164A5"/>
                            </svg>             
                            </p>
                            <p>업로드</p>
                        </button>
                        {files?.map((x, i) => {
                            return (
                                <div key={i} style={{ backgroundImage: `url(${x?.base64})`}}>
                                    <button 
                                        type="button"
                                        onClick={() => {
                                            seterrmsg(errmsg?.map(( xe, ie ) => ''));
                                            setfiles(files?.filter((x2, i2) => i2 !== i));
                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                            <rect x="0.333984" width="16" height="16" rx="4" fill="#101010"/>
                                            <path fillRule="evenodd" clipRule="evenodd" d="M5.5683 5.23431C5.88072 4.9219 6.38725 4.9219 6.69967 5.23431L8.53398 7.06863L10.3683 5.23431C10.6807 4.9219 11.1873 4.9219 11.4997 5.23431C11.8121 5.54673 11.8121 6.05327 11.4997 6.36569L9.66536 8.2L11.4997 10.0343C11.8121 10.3467 11.8121 10.8533 11.4997 11.1657C11.1873 11.4781 10.6807 11.4781 10.3683 11.1657L8.53398 9.33137L6.69967 11.1657C6.38725 11.4781 5.88072 11.4781 5.5683 11.1657C5.25588 10.8533 5.25588 10.3467 5.5683 10.0343L7.40261 8.2L5.5683 6.36569C5.25588 6.05327 5.25588 5.54673 5.5683 5.23431Z" fill="white"/>
                                        </svg>                
                                    </button>
                                </div>
                            );
                        })}

                    </div>
                </>
                }
                {errmsg[3] !== '' &&
                <div>
                    <p className="input_error"><span></span>{errmsg[3]}</p>
                </div>
                }
                <div className='loginbutton' style={{ marginTop: 20 }}>
                    <Button
                        // disabled={!submitflag}
                        onPress={() => {
                            if(submitflag === true){
                                let sender = {
                                    email: email
                                }
                                if(!regEmail.test(email)) {
                                    seterrmsg(errmsg?.map(( xe, ie ) => ie === 0 ? '이메일 형식이 올바르지 않습니다.' : xe));
                                    return;
                                }

                                APIS.postData('/v1/login/emailCheck', sender).then(({ data }) => {
                                    if(data){
                                        registerSubmit();
                                    }
                                }).catch(({ response }) => {
                                    const { data } = response;
                                    if(data?.code === 0){
                                        seterrmsg(errmsg?.map(( xe, ie ) => ie === 0 ? data?.msg : xe));
                                    }
                                    if(data?.code === 1){
                                        dispatch(
                                            open({
                                                component: '탈퇴된 계정입니다. 복구하시겠습니까?',
                                                title: '복구하기',
                                                button: "복구",
                                                buttonCencle: "닫기",       
                                                titleviewer: true,                 
                                                alert: false,
                                                onPress: () => {
                                                    dispatch(loadingflas({ loading: true }));
                                                    let sender = {
                                                        idx: data?.msg,
                                                    }
                                                    APIS.postData('/v1/login/restore', sender).then(({ data }) => {
                                                        if(data){
                                                            dispatch(
                                                                open({
                                                                    component: `복구되었습니다.`,
                                                                    title: '알림',
                                                                    titleviewer: true,
                                                                    alert: false,
                                                                    button: "확인",
                                                                    onPress: () => {
                                                                        dispatch(close());
                                                                        navigate("/Login");
                                                                    }
                                                                })
                                                            ); 
                                                        }
                                                    }).catch(({ response }) => {
                                                        const { data } = response;
                                                    }).finally(() => {
                                                        dispatch(loadingflas({ loading: false }));
                                                    }); 
                                                },
                                                onCancelPress: () => {
                                                    dispatch(close());
                                                }
                                            })
                                        );  
                                    }
                                }).finally(() => {
                                });
                                
                            }
                        }}
                        buttonTxt={'가입완료'}
                    />
                </div>     
            </div>
        </Layout>
    )
}

